/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/messaging/utils/PopupWindow',['../../lib/@waca/core-client/js/core-client/utils/BrowserUtils'], function (BrowserUtils) {
	'use strict';

	function monitorWindow(checkWindow) {
		window.__collabPopupWindowCheckId = window.setTimeout(checkWindow, 1000);
		return true;
	}

	function cleanupGlobals() {
		if (window.__collabPopupWindowCheckId) {
			window.clearTimeout(window.__collabPopupWindowCheckId);
			window.__collabPopupWindowCheckId = null;
		}
		window.__collabPopupWindow = null;
	}

	return {
		/**
   * Open a window popup and monitor its closing. One single popup is allowed at any given time.
   * @static
   * @param {string} url the window's url
   * @param {string} name the window's name
   * @param {string} options the window's options
   * @param {function} callback called when the popup window is detected to be closed
   * @returns {boolean} success or failure
   */
		open: function open(url, name, options, callback) {
			// if the window exists, close it first
			if (window.__collabPopupWindow) {
				window.__collabPopupWindow.close();
				cleanupGlobals();
			}

			// open the popup window
			window.__collabPopupWindow = window.open(url, name, options);
			if (window.__collabPopupWindow) {
				try {
					window.__collabPopupWindow.focus();
				} catch (error) {
					void error;
					// looks like popups are not allowed
					return false;
				}
			} else {
				// returns false except for IE, which we can't tell if pop-ups are blocked or not
				return BrowserUtils.isIE();
			}

			var checkWindow = function checkWindow() {
				if (window.__collabPopupWindow) {
					if (!window.__collabPopupWindow.closed) {
						// window is still up, check again
						monitorWindow(checkWindow);
					} else {
						// window is now closed
						callback();
						cleanupGlobals();
					}
				}
			};

			// monitor the closing of this popup window
			return monitorWindow(checkWindow);
		},

		/**
   * Calculates the position of a centered popup window.
   * @param {number} width
   * @param {number} height
   * @returns {object} top & left coordinates
   */
		center: function center(width, height) {
			var el = document.documentElementl;
			var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
			var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;
			var newWidth = window.innerWidth ? window.innerWidth : el.clientWidth ? el.clientWidth : screen.width;
			var newHeight = window.innerHeight ? window.innerHeight : el.clientHeight ? el.clientHeight : screen.height;

			return {
				left: (newWidth - width) / 2 + dualScreenLeft,
				top: (newHeight - height) / 2 + dualScreenTop
			};
		}
	};
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

